import React from "react";
import { PQ, PQ_IMG } from "@/content/pesquisa";
import { Container, Eyebrow, Body, ArrowLink, Reveal } from "@/components/site/ui";

// Núcleo doutoral: circularidade e criação de valor (Home).
const ValorBlock = () => (
    <section data-testid="home-valor" data-section-id="valor" className="relative py-24 md:py-32 overflow-hidden">
        <img src={PQ_IMG.circular} alt="Pequena oficina de reaproveitamento de materiais iluminada por uma lâmpada" loading="lazy" className="absolute inset-0 w-full h-full object-cover object-[75%_center]" style={{ filter: "saturate(0.6) brightness(0.8)" }} />
        <div aria-hidden="true" className="absolute inset-0 bg-[#0A1812]/80 md:bg-[#0A1812]/45" />
        <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-r from-[#0A1812] via-[#0A1812]/90 to-[#0A1812]/60" />
        <Container className="relative">
            <Reveal className="max-w-3xl">
                <Eyebrow>Núcleo doutoral · economia circular e produção sustentável</Eyebrow>
                <h2 data-testid="valor-title" className="font-serif font-light text-[30px] sm:text-[38px] lg:text-[44px] leading-[1.12] tracking-[-0.01em] text-[#F2EFE5] text-balance">{PQ.circular.title}</h2>
                <Body className="mt-8 max-w-2xl">{PQ.circular.text}</Body>
                <p className="mt-8 font-serif italic font-light text-[20px] md:text-[23px] leading-[1.45] text-[#D7D1BF] border-l-2 border-[#C7A659] pl-6">{PQ.valor.pergunta}</p>
                <div className="mt-10">
                    <ArrowLink to="/pesquisa" testId="home-valor-link">Circularidade e criação de valor</ArrowLink>
                </div>
            </Reveal>
        </Container>
    </section>
);

export default ValorBlock;
